import script from "./DetailList.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailList.vue?vue&type=script&setup=true&lang=js"

import "./DetailList.vue?vue&type=style&index=0&id=63a1a808&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63a1a808"]])

export default __exports__